import _styled from "@emotion/styled-base";
import React from 'react';
import { styledWithTheme } from "../../context";
import { filterProps } from "../../utils";
import { DATE_MARKER_SIZE, CORNER_DATE_MARKER_SIZE, DATE_MARKER_COLOR } from "./constants";
import { jsx as ___EmotionJSX } from "@emotion/core";
var CornerMarker = styledWithTheme('div')(function (_ref) {
  var theme = _ref.theme,
      isInverted = _ref.isInverted;
  return {
    position: 'absolute',
    top: CORNER_DATE_MARKER_SIZE / 2,
    right: 0,
    width: 0,
    height: 0,
    transform: 'rotate(45deg)',
    borderLeft: "".concat(CORNER_DATE_MARKER_SIZE, "px solid transparent"),
    borderRight: "".concat(CORNER_DATE_MARKER_SIZE, "px solid transparent"),
    borderBottom: "".concat(CORNER_DATE_MARKER_SIZE, "px solid ").concat(theme.selectors.color(isInverted ? 'neutral0' : DATE_MARKER_COLOR))
  };
});

var CornerMarkerWrapper = /*#__PURE__*/_styled('div', {
  // stylelint-disable-next-line
  shouldForwardProp: filterProps(['size']),
  target: "e982skz0"
})(function (_ref2) {
  var size = _ref2.size;
  return {
    width: size,
    height: size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var CornerDateMarker = function CornerDateMarker(_ref3) {
  var children = _ref3.children,
      hasMarker = _ref3.hasMarker,
      isInverted = _ref3.isInverted,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? DATE_MARKER_SIZE : _ref3$size;

  if (!hasMarker) {
    return ___EmotionJSX(React.Fragment, null, children);
  }

  return ___EmotionJSX(CornerMarkerWrapper, {
    size: size
  }, ___EmotionJSX(CornerMarker, {
    isInverted: isInverted
  }), children);
};

CornerDateMarker.displayName = 'CornerDateMarker';
export default CornerDateMarker;